// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowDropDown } from '@mui/icons-material';
import { Tooltip, Popover, MenuList, MenuItem, Button, Typography } from '@mui/material';

const menuItems = [
  {
    label: 'Home',
    route: '/',
  },
  {
    label: 'Registry',
    route: '/registry/onboarding',
  },
];

export const ModulesPopoverMenu: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const navigate = useNavigate();
  const routes = menuItems;
  const l = useLocation();
  const page = l.pathname.split('/')?.[1];
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const nav = (route: string) => {
    navigate(route);
    handleClose();
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <Tooltip title="Click for other modules">
        <Button sx={{ ml: 2 }} onClick={handleClick} endIcon={<ArrowDropDown />} variant="text">
          {page || 'home'}
        </Button>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <MenuList>
          {routes.map((i) => (
            <MenuItem
              selected={page === i.label.toLocaleLowerCase()}
              key={i.label}
              onClick={() => nav(i.route)}
            >
              <Typography variant="body2">{i.label}</Typography>
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </>
  );
};
